import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useReducer,
} from "react";

export const constants = {
  ACTION_TOGGLE_THEME: "ACTION_TOGGLE_THEME",
  ACTION_TOGGLE_SIDEBAR: "ACTION_TOGGLE_SIDEBAR",
  ACTION_CLICK_EMOJI: "ACTION_CLICK_EMOJI",
  ACTION_INIT_CONFIG_DATA: "ACTION_INIT_CONFIG_DATA",
  ACTION_INIT_I18N: "ACTION_INIT_I18N",
  THEME_LIGHT: "THEME_LIGHT",
  THEME_DARK: "THEME_DARK",
};

const defaultLayoutState = {
  theme: constants.THEME_LIGHT,
  sidebarOpen: false,
  i18n: {},
};

const layoutStateReducer = (state, action) => {
  const { type, payload } = action;
  false &&
    console.log(
      "💎💎💎💎💎💎💎💎__debug from layoutStateReducer" +
        JSON.stringify({
          type: type,
          payload: payload,
        })
    );
  switch (type) {
    case constants.ACTION_TOGGLE_THEME:
      return {
        ...state,
        theme:
          state.theme === constants.THEME_LIGHT
            ? constants.THEME_DARK
            : constants.THEME_LIGHT,
      };
    case constants.ACTION_TOGGLE_SIDEBAR:
      return { ...state, sidebarOpen: !state.sidebarOpen };
    case constants.ACTION_INIT_I18N:
      return { ...state, i18n: payload.i18n };

    default:
      return state;
  }
};

const LayoutContext = createContext({
  theme: constants.THEME_LIGHT,
  sidebarOpen: false,
  i18n: {},
  toggleTheme: () => {},
  toggleSidebar: () => {},
  clickEmoji: () => {},
});

const WithLayoutContext = ({ children }) => {
  const [state, dispatch] = useReducer(layoutStateReducer, defaultLayoutState);

  // Memoize dispatch functions so they don't change on every render.
  const toggleTheme = useCallback(
    () => dispatch({ type: constants.ACTION_TOGGLE_THEME }),
    []
  );
  const toggleSidebar = useCallback(
    () => dispatch({ type: constants.ACTION_TOGGLE_SIDEBAR }),
    []
  );
  const clickEmoji = useCallback(
    (emoji_number = "emoji_01") =>
      dispatch({
        type: constants.ACTION_CLICK_EMOJI,
        payload: { emoji: emoji_number },
      }),
    []
  );

  // Memoize the context value so that it only changes when state or the memoized functions change.
  const contextValue = useMemo(
    () => ({
      theme: state.theme,
      sidebarOpen: state.sidebarOpen,
      i18n: state.i18n,
      toggleTheme,
      toggleSidebar,
      clickEmoji,
    }),
    [
      state.theme,
      state.sidebarOpen,
      state.i18n,
      toggleTheme,
      toggleSidebar,
      clickEmoji,
    ]
  );
  useEffect(() => {
    false &&
      console.log(
        JSON.stringify({
          FROM: "__debug [LayoutContext] 🌺🌺🌺🌺🌺🌺🌺🌺🌺useEffect state",
          state,
        })
      );
  }, [state]);

  return (
    <LayoutContext.Provider value={contextValue}>
      {children}
    </LayoutContext.Provider>
  );
};

export { LayoutContext, WithLayoutContext };
